import store from "@/redux/store";

import React, { useState } from "react";
import { useParams } from "react-router-dom";

//import {showLoader,hideLoader} from "actions/types";
import { connect } from "react-redux";
import { Login } from "@/views/authorisation/Login";
import { Resetpassword } from "@/views/authorisation/ResetPassword";
import ResetPasswordSet from "@/views/authorisation/ResetPassword2";
import Registration from "@/views/authorisation/Registration"; 
import { loginUser, resetpassword, resetpassword2 } from '@/reducers/Authorisation'
import CookieHelper from "helpers/cookie";

import { Link, useNavigate, useLocation } from "react-router-dom";

export const RESETPASSWORD = "RESET_PASSWORD";
export const RECOVERPASSWORD = "RECOVER_PASSWORD";
export const REGISTRATION = "REGISTRATION";

    
class RegistrationController extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, isLoaded: false, secret: null, view1: "" };
  }

    
    onRegistrationEventHandler = async (data) => {
        const { dispatch, hash } = this.props;

     try {
        //await dispatch(loginUser(data));
      } catch (err) {
        console.error('Failed to save the post: ', err)
      } finally {

      }
    };

  
  render() {
      return (<Registration {...this.props} onRegistrationEvent={this.onRegistrationEventHandler} key="RP1"/>);
 
  }
}

const RegistrationControllerInit = (props) => {
    
  return (
    <RegistrationController
      {...props}
    />
  );
};

function mapStateToProps(state) {
    const {AuthReducer} = state;
    const {key} = AuthReducer;
    const {hash} = useParams();
    const navigate = useNavigate();

  return {
      hashKey: hash,
      AuthReducer: {AuthReducer},
      state: {...AuthReducer},
      navigate: navigate,
      key: {key}
  };
}


export default connect(mapStateToProps)(RegistrationControllerInit);
